<template>
    <v-tab-item :value="thisTab" class="fill-height">
        <v-layout column justify-center class="h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                <div class="text-center mb-20 mb-lg-40">
                    <h3 class="tit mb-8 mb-lg-16">계약 대상자 선택</h3>
                    <p class="page-text--lg grey-6--text">근로계약을 체결할 대상자를 선택해 주세요.</p>
                </div>

                <v-card rounded="lg" flat color="grey-f7" class="mb-20 mb-lg-40" style="overflow: unset;">
                    <div class="pa-20 pa-md-30 pa-lg-40">
                        <v-row align="center" class="row--small">
                            <v-col cols="12" md="auto" class="mb-10 mb-md-0">
                                <p class="page-text font-weight-medium min-w-md-100px min-w-lg-160px">채용공고 선택</p>
                            </v-col>
                            <v-col>
                                <v-row class="row--small">
                                    <v-col cols="12" sm="">
                                        <autocomplete-company-recruitments
                                            v-model="selectedRecruitment"
                                            v-bind="{
                                                ...attrs_input,
                                                loading,
                                                returnObject: true,
                                                placeholder: '채용공고를 선택해주세요',
                                            }"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="auto">
                                        <v-btn
                                            v-bind="{
                                                disabled: !selectedRecruitment,
                                                to: selectedRecruitment ? `/recruitments/${selectedRecruitment?._id}` : undefined,
                                                target: '_blank',
                                                block: true,
                                                color: 'primary',
                                            }"
                                        >
                                            <span> 자세히 보기 </span>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>

                <v-row align="center" class="mb-10 mb-lg-20">
                    <v-col cols="auto">
                        <v-btn v-bind="{ disabled: !applications.length }" text class="select-all-btn" @click="toggleSelectAll">
                            <v-simple-checkbox :value="isAllSelected" color="primary" @click.stop.capture="toggleSelectAll" />
                            <span>전체선택</span>
                        </v-btn>
                    </v-col>
                    <v-spacer />
                    <v-col cols="auto">
                        <span class="font-weight-bold"> 총 {{ selectedApplicationsLegth?.format?.() }}명 선택됨 </span>
                    </v-col>
                    <v-col cols="auto">
                        <v-combobox v-model="limit" v-bind="{ ...attrs_input, items: [10, 20, 50] }" />
                    </v-col>
                </v-row>

                <form-applications v-model="selectedApplications" v-bind="{ items: applications }" />

                <v-pagination v-model="page" :length="pageCount" :total-visible="11" color="primary" @input="search" />
            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn v-bind="{ loading }" outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="prev">
                    <span class="grey-6--text">취소</span>
                </v-btn>
                <v-btn v-bind="{ loading }" color="primary" class="min-w-140px min-w-lg-160px" @click="emit">
                    <span>저장하기</span>
                </v-btn>
            </div>
            <v-fade-transition>
                <v-overlay v-show="loading" color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </v-layout>
    </v-tab-item>
</template>

<script>
import api from "@/api";
import { APPLICATION_STAGES, attrs_input } from "@/assets/variables";
import { TABS } from "../lib";

import AutocompleteCompanyRecruitments from "@/components/dashboard/company/dumb/autocomplete-company-recruitments.vue";
import FormApplications from "../form-applications.vue";

let thisTab = TABS.SELECT.value;

export default {
    components: {
        AutocompleteCompanyRecruitments,
        FormApplications,
    },
    props: {
        value: { type: Array, default: () => [] }, // applications
        tab: { type: String, default: TABS.CREATE.value },
        shows: { typs: Boolean, default: false },
    },
    data: () => ({
        selectedRecruitment: null, // 선택된 채용공고
        applications: [], // 선택된 채용공고 하위 지원서
        summary: { totalCount: 0 }, // 선택된 채용공고 하위 지원서 개수
        page: 1,
        limit: 10,

        selectedApplications: [],

        loading: false,

        thisTab,
        attrs_input,
    }),
    computed: {
        isOn() {
            return this.shows && this.tab == thisTab;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        isAllSelected() {
            return 0 < this.applications.length && !this.applications.some((item) => !this.selectedApplications.some(({ _id }) => _id == item._id));
        },
        selectedApplicationsLegth() {
            return this.applications.filter((item) => this.selectedApplications.some(({ _id }) => _id == item._id)).length;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        isOn(isOn) {
            if (isOn) this.init().then(this.search);
        },
        value() {
            this.sync();
        },
        selectedRecruitment() {
            this.search();
        },
        limit() {
            this.onChangeLimit();
        },
    },

    methods: {
        async init() {
            this.selectedRecruitment = null;
            this.applications = [];
            this.summary = { totalCount: 0 };
            this.page = 1;
            this.limit = 10;
            this.loading = false;

            this.sync();
        },

        sync() {
            this.selectedApplications = [...this.value];
        },

        emit() {
            this.$emit("input", this.selectedApplications);
            this.prev();
        },

        prev() {
            this.$emit("prev");
        },

        async search() {
            if (!this.selectedRecruitment) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit } = this;

                const { summary, applications } = await api.v1.company.recruitments.applications.gets({
                    _recruitment: this.selectedRecruitment?._id,
                    headers: { skip, limit },
                    params: { stage: APPLICATION_STAGES.ON_RECRUIT.value },
                });
                this.summary = summary;
                this.applications = applications;
            } finally {
                this.loading = false;
            }
        },

        toggleSelectAll() {
            if (this.isAllSelected) this.selectedApplications = this.selectedApplications.filter((item) => !this.applications.some(({ _id }) => _id == item._id));
            else this.selectedApplications = [...this.value].concat(...this.applications.filter((item) => !this.value.some(({ _id }) => _id == item._id)));
        },

        onChangeLimit() {
            this.page = 1;
            this.search();
        },
    },
};
</script>

<style lang="scss" scoped>
.select-all-btn {
    min-width: unset;
    height: unset;
    padding: 0;

    &::before {
        display: none;
    }
}
</style>
